<template>
  <div class="itemActions">
    <FontAwesomeIcon
      :icon="['far', 'trash-can']"
      class="icon"
      @click="deleteItem"
      v-if="actions?.includes('delete')"
    />
    <FontAwesomeIcon
      @click="editItem"
      :icon="['far', 'pencil-alt']"
      class="icon"
      v-if="actions?.includes('edit')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { useStructuredResumeStore } from '@/store/pinia/structuredResume'
import {
  GlobalEvents,
  useGlobalListeners,
} from '@/composables/useGlobalListeners'
import { useConfirmationDialog } from '@/composables/useConfirmationDialog'

export default defineComponent({
  name: 'ItemActions',
  props: {
    section: {
      type: String as PropType<string>,
      required: true,
    },
    index: {
      type: Number as PropType<number>,
      required: true,
    },
    uuid: {
      type: String as PropType<string>,
      required: false,
    },
    actions: {
      type: Array as PropType<string[]>,
      required: false,
    },
    confirmDelete: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: true,
    },
  },
  setup(props) {
    const store = useStructuredResumeStore()
    const { publishEvent } = useGlobalListeners()
    const { appConfirm } = useConfirmationDialog()

    const deleteItem = async () => {
      if (props.confirmDelete) {
        if (
          !(await appConfirm(
            'Are you sure you want to delete this item from your resume?',
            'Delete Item',
            'Delete',
            'danger'
          ))
        )
          return
      }
      store.removeSectionItem(props.section, props.index)
    }

    const editItem = () => {
      publishEvent(GlobalEvents.PE_EDIT_SECTION, {
        section: props.section,
        uuid: props.uuid,
      })
    }

    return {
      deleteItem,
      editItem,
    }
  },
})
</script>

<style lang="postcss" scoped>
.itemActions {
  @apply pl-1 absolute top-0 right-0 bottom-0 translate-x-full flex-col text-jsBlue-90 z-50 space-y-1 z-fixedLayer;
  .icon {
    @apply p-1 cursor-pointer text-sm rounded bg-jsBlue-10;
    &:hover {
      @apply text-white bg-primary;
    }
  }
}
</style>
